<template>
    <project-step-container
            prev-to="js_rapid_experiments_with_customers_14"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="first-form">
            <b-col cols="12" class=" simple-text" tabindex="0">
                 {{getMessage(15, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>

        <project-step-activity
            class="mt-4"
            :url="getMessage(15, 'rapidexperiment-activity')"
            :title="getMessage(15, 'rapidexperiment-activity-text')"
        >
        </project-step-activity>

    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import ProjectStepActivity from "../../../core/Components/ProjectStepActivity"
    import {Steps} from "@/modules/JobShadow/Utils";
    import {ConflictSyn, Project} from "@/core/Utils";


    export default {
        name: "RapidExperimentsWithCustomers15",
        components: {ProjectStepContainer, ProjectStepActivity},
        data(){
            return{
                step:Steps.FORM_JS_RAPID_EXPERIMENTS_INFORMATION,
            }
        },
        methods:{
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_rapid_experiments_with_customers_16', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .subtitle
        font font-sourcesans-bold
        font-size 14px
       .byc-container
        background-color color-1
        padding 15px 10px
        min-height 100vh
        max-height 100vh
        overflow hidden

    .skip-link
        padding-right 19px
        font font-poppins-semibold
        font-size 16px
        letter-spacing 0.8px
        color color-5
        cursor pointer

        &:hover
            color color-5

    .title
        padding 0 29px
        font font-poppins-semibold
        letter-spacing 0.53px
        font-size 21px
        color black

    .sub-title
        padding 0 29px
        font font-sourcesans-regular
        font-size 16px
        color color-4

    .content
        background-color white

    .divider
        padding-left 0
        padding-right 0

        &hr
            color black

    .section-title
        font font-poppins-bold
        font-size 16px
        color black
        letter-spacing 0.4px

    .answer-grey
        color color-4

    .sketch-image
        max-width: 98%
        max-height: 60vh

</style>
